import 'normalize.css'
import 'styles/App.less'
import React, { Component, PropTypes } from 'react'
import ReactDOM from 'react-dom'
import { connect } from 'react-redux'
import Helmet from 'react-helmet'
import classNames from 'classnames'
import Modal from 'components/Modal'
import Footer from 'components/Utils/Footer'
import Spinner from 'components/Utils/Spinner'
import Alert from 'components/Utils/Alert'
import AlertMini from 'components/Utils/AlertMini'
import Menu from 'components/Utils/Menu'
import * as actions from 'actions'
import TopWrapper from 'components/Utils/TopWrapper'

class App extends Component {
  constructor(props) {
    super(props)
    this.state = {
      scrollY: 0,
      alertIsMinimized: false,
      scrollDirection: true          // true === scrolling down
    }
  }
  componentWillReceiveProps(nextProps) {
    this.setState({
      alertIsMinimized: nextProps.alertIsMinimized,
      menuUrl: nextProps.menuUrl
    })
  }
  componentDidMount() {
    let node = ReactDOM.findDOMNode(this.refs.parallax)
    node.addEventListener('scroll', this.stickyScroll.bind(this), false)
  }
  componentWillUnmount() {
    let node = ReactDOM.findDOMNode(this.refs.parallax)
    node.removeEventListener('scroll', this.stickyScroll, false)
  }
  stickyScroll = (e) => {
    let node = ReactDOM.findDOMNode(this.refs.parallax)
    if (node.scrollTop <= 350 || window.location.hash == '#sempai') {
      this.setState({ scrollY: node.scrollTop })
    }
    if (this.state.alertIsMinimized && node.scrollTop <= 100) {
      this.props.dispatch(actions.token.toggleMinimizeAlert(false))
    }
  }
  render() {
    let { routes, children, dispatch } = this.props

    let childrenWithProps = React.Children.map(this.props.children,
      (child) => React.cloneElement(child, {
        scrollY: this.state.scrollY,
        alertIsMinimized: this.state.alertIsMinimized,
        scrollDirection: this.state.scrollDirection
      })
    )

    return (
      <div className='app-component'>
        <Helmet
          title="Gakko"
          meta={[
                  {'name': 'description', 'content': 'GAKKO (学校): A global collaboration of people who create learning environments with a sense of belonging.'},
                  {'name': 'viewport', 'content': 'width=device-width'}
                ]}
          link={[
                  {'rel': 'shortcut icon', 'type': 'image/x-icon', 'href': 'favicon.ico'},
                  {'rel': 'stylesheet', 'type': 'text/css', 'href': 'https://cdnjs.cloudflare.com/ajax/libs/slick-carousel/1.6.0/slick.min.css'},
                  {'rel': 'stylesheet', 'type': 'text/css', 'href': 'https://cdnjs.cloudflare.com/ajax/libs/slick-carousel/1.6.0/slick-theme.min.css'}
              ]}
          script={[
                  {'innerHTML': `
                    !function(f,b,e,v,n,t,s)
                    {if(f.fbq)return;n=f.fbq=function(){n.callMethod?
                    n.callMethod.apply(n,arguments):n.queue.push(arguments)};
                    if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
                    n.queue=[];t=b.createElement(e);t.async=!0;
                    t.src=v;s=b.getElementsByTagName(e)[0];
                    s.parentNode.insertBefore(t,s)}(window,document,'script',
                    'https://connect.facebook.net/en_US/fbevents.js');
                     fbq('init', '775982179238367'); 
                    fbq('track', 'PageView');
                  `}
            ]}
          noscript={[
                  {'innerHTML': `
                    <img height='1' width='1' src='https://www.facebook.com/tr?id=775982179238367&ev=PageView&noscript=1'/>
                  `}
            ]}
        />

        <Modal/>
        <TopWrapper alertIsMinimized={this.state.alertIsMinimized} scrollY={this.state.scrollY} {...this.props}/>
        <div className='app-body parallax' ref="parallax">
          {childrenWithProps}
        </div>
      </div>
    )
  }
}
App.contextTypes = {
}
App.propTypes = {
}
function mapStateToProps(state, ownProps) {
  return {
    routes: ownProps,
    alertIsMinimized: state.token.alertIsMinimized,
    menuUrl: state.token.menuUrl
  }
}

export default connect(mapStateToProps)(App)



// WEBPACK FOOTER //
// ./src/components/App.js